import actions from "./actions"

const {populateProfileLookUpInformation} = actions;

export const populateProfileLookUpInfo = (account) => {
    return(dispatch) => {
        dispatch(populateProfileLookUpInformation(account));
    }
}